<template>
  <main @touchmove.capture="dialogTouchMove($event)">
    <div class="dialog-main">
      <div class="mask"></div>
      <div class="dialog-box">
        <h3 class="title">
          垫付金额保障<span class="title-risk"><i class="iconfont icon-tubiaozhizuomoban"></i>保障中</span>
        </h3>
        <div class="desc-list">
          <ul class="list-box">
            <li>
              当前商品在<template>
                <div class="platformTypeBox">
                  <div class="inner-box">
                    <img class="icon" :src="PLATFORM_TYPE_DETAIL[platformType].iconImg" />
                    <span :style="'color:' + PLATFORM_TYPE_DETAIL[platformType].themeColor">{{ PLATFORM_TYPE_DETAIL[platformType].officialWebsite }}</span>
                  </div>
                </div></template
              >成交，用户享受一切{{ PLATFORM_TYPE_DETAIL[platformType].collectively }}购物权益。
            </li>
            <li>在未确认收货前，{{ PLATFORM_TYPE_DETAIL[platformType].collectively }}不会将资金转给商家，因此不必担心垫付金额后，无法收到货物及返利。</li>
          </ul>
        </div>
        <div class="sure-btn" @click="close">我知道了</div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'RiskDialog',
  props: {
    platformType: {
      type: Number,
      default: 0
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    dialogTouchMove(e) {
      e.preventDefault()
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-main {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
}
.mask {
  background: #000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  opacity: 0.7;
  animation-fill-mode: backwards;
  animation: opacityAnim 0.1s ease-in;
}
.dialog-box {
  position: relative;
  width: 88%;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 20px 25px 15px;
  z-index: 999;
  background: #fff;
  border-radius: 5px;
  font-size: 15px;
  animation-fill-mode: backwards;
  animation: opacityAnim 0.2s ease-in;
}
.dialog-box .title {
  font-size: 18px;
}
.title-risk {
  display: inline-block;
  color: #60c781;
  background: #effaf3;
  font-size: 14px;
  padding: 2px 5px;
  border-radius: 3px;
  margin-left: 5px;
}
.dialog-box .desc-list {
  padding: 30px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
}
.list-box li {
  position: relative;
  margin-bottom: 20px;
  padding: 0 0 0 20px;
  box-sizing: border-box;
}
.list-box li:last-child {
  margin-bottom: 0;
}
.list-box li::before {
  content: '';
  position: absolute;
  left: 2px;
  top: 7px;
  display: block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #60c781;
}

.platformTypeBox {
  display: inline-block;
  margin: 0 4px;
  height: 100%;

  .inner-box {
    position: relative;
    display: flex;
    padding-left: 20px;
  }
  .icon {
    position: absolute;
    bottom: 50%;
    left: 0;
    display: block;
    width: 16px;
    height: 16px;
    transform: translateY(50%);
  }
}
// .list-box .tag {
//   margin: 0 4px;
// }
// .iconfontImg {
//   position: relative;
//   top: 2.5px;
//   display: inline-block;
//   width: 16px;
//   height: 16px;
//   background: url('~@/assets/icon/icon3.png') no-repeat;
//   background-size: 100% 100%;
//   margin-right: 1px;
// }
// .list-box .tag.tb {
//   color: #ff9900;
// }
// .list-box .tag.pdd {
//   color: #e02e24;
// }
// .list-box .tag.jd {
//   color: #e31912;
// }
.dialog-box .sure-btn {
  margin: 10px auto 0 auto;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: #000;
  width: 120px;
  border-radius: 20px;
}
// .dyBox {
//   display: inline-block;
//   color: #e83f41;
//   margin-right: 2px;
//   .tag.dy {
//     display: inline-block;
//     .iconBox {
//       display: flex;
//       align-items: center;
//       justify-content: space-around;
//       border-radius: 4px;
//       width: 20px;
//       height: 20px;
//       background-color: #000;
//       color: #fff;
//     }
//   }
// }
</style>
